export const ROLE_OPTIONS = [
  { value: "customer", label: "Customer" },
  { value: "author", label: "Author" },
];
